"use client"

import { useState } from "react"
import { AlertTriangle } from "lucide-react"
import { NetworkDiagnosticModal } from "./network-diagnostic-modal"

export function NetworkSection() {
    const [isModalOpen, setIsModalOpen] = useState(false)

    const handleNetworkDiagnostic = () => {
        setIsModalOpen(true)
    }

    const handleRetryConnection = () => {
        console.log("Retrying connection...")
        // Placeholder for retry connection functionality
        alert("Retrying connection. This feature will be implemented later.")
    }

    const closeModal = () => {
        setIsModalOpen(false)
    }

    return (
        <>
            <div className="device-group">
                <div className="device-label">Network</div>
                <div className="network-status">
                    {/* <AlertTriangle className="network-icon" /> */}
                    <div className="network-content">
                        <h3>Experiencing Network Issues</h3>
                        <p>We're having trouble maintaining a stable connection. Please check your internet or try reconnecting.</p>

                        <div className="network-actions">
                            <button className="network-button primary" onClick={handleNetworkDiagnostic}>
                                Network Diagnostic
                            </button>
                            <button className="network-button secondary" onClick={handleRetryConnection}>
                                Retry Connection
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <NetworkDiagnosticModal isOpen={isModalOpen} onClose={closeModal} />
        </>
    )
}
